import requests from '../../../../redux/reducer/requests';
import elf from '../../../../redux/reducer/elf';
import { useDispatch } from 'react-redux';

export default function useElfCallbacks() {
  const dispatch = useDispatch();

  return {
    setActiveRoom: (activeRoom) => dispatch(requests.thunks.setActiveRoom(activeRoom)),
    addAnimations: (animations) => dispatch(elf.actions.addAnimations(animations)),
    resetAnimation: (animations) => dispatch(elf.actions.resetAnimation(animations)),
    setIsDressed: (isDressed) => dispatch(elf.actions.setIsDressed(isDressed)),
    addOutsideAnimations: (animations) => dispatch(elf.actions.addOutsideAnimations(animations)),
    resetOutsideAnimations: (animations) => dispatch(elf.actions.resetOutsideAnimations(animations)),
    setIsVisibleRoom: (isVisible) => dispatch(elf.actions.setIsVisibleRoom(isVisible)),
    setIsVisible: (isVisible) => dispatch(elf.actions.setIsVisible(isVisible)),
    setIsAnimation: (isAnimation) => dispatch(elf.actions.setIsAnimation(isAnimation)),
  };
}
